import { useSyncExternalStore } from 'react';

/** Même seuil que les règles `@media` de `index.scss` : téléphone, ou tablette en portrait. */
export const MOBILE_QUERY = '(max-width: 767.98px)';

const media = () => window.matchMedia(MOBILE_QUERY);

const subscribe = (onChange: () => void) => {
	const query = media();
	query.addEventListener('change', onChange);

	return () => query.removeEventListener('change', onChange);
};

export default function useIsMobile(): boolean {
	return useSyncExternalStore(subscribe, () => media().matches);
}
